module.exports = __webpack_public_path__ + "static/img/7.8645e9c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/1/sp/7.png
// module id = WOf6
// module chunks = 0